export const PLATFORM_SOURCE_REGISTER = "PlatformSourceRegister_v1";
export const UPLOAD_FILE_SESSION_ID = "UploadFileSessionId_v1";
